import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight, User, BookOpen } from "lucide-react";
import { Button } from "../ui/button";
import { blogs } from "../../mock/mock";

const BlogSection = () => {
  const featured = blogs.slice(0, 3);
  const formatDate = (d) =>
    new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 border border-orange-200 mb-4">
              <BookOpen className="w-4 h-4 text-orange-700" />
              <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">Blog & Insights</span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 leading-tight">
              Stories, Tips &<br />
              <span className="text-orange-600">Parenting Wisdom</span>
            </h2>
            <p className="text-stone-600 mt-3">
              Thoughtful articles on early childhood, Sanatan values and modern parenting.
            </p>
          </div>
          <Link to="/blog">
            <Button variant="outline" className="border-2 border-orange-600 text-orange-700 hover:bg-orange-50 rounded-full h-12 px-6">
              View All Articles <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </Link>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {featured.map((b) => (
            <Link
              key={b.id}
              to={`/blog/${b.id}`}
              className="group bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 border border-orange-100 flex flex-col"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={b.image}
                  alt={b.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <span className="absolute top-4 left-4 bg-white/95 backdrop-blur-sm text-orange-700 text-[10px] font-bold px-3 py-1.5 rounded-full uppercase tracking-wider shadow">
                  {b.category}
                </span>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <div className="flex items-center gap-3 text-xs text-stone-500 mb-3">
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {formatDate(b.date)}</span>
                  <span className="flex items-center gap-1"><Clock className="w-3 h-3" /> {b.readTime}</span>
                </div>
                <h3 className="font-display font-bold text-lg text-stone-800 mb-2 line-clamp-2 group-hover:text-orange-700 transition-colors">
                  {b.title}
                </h3>
                <p className="text-sm text-stone-600 mb-4 line-clamp-3 flex-1">{b.excerpt}</p>
                <span className="inline-flex items-center gap-1 text-sm font-bold text-orange-700 group-hover:gap-2 transition-all">
                  Read More <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
